export default {
  created: function created() {
    this.uuid = Math.random().toString(36).substring(3, 8);
  }
};


// WEBPACK FOOTER //
// ./node_modules/vux/src/mixins/uuid.js